import Vue from 'vue'
export const toastBus = new Vue()
export const toast = (message, type = 'success') => toastBus.$emit('show', { message, type })
